import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import styled from "styled-components";
import { Colors } from "../../../../utils/colors/colors";
import Title from "../../../../utils/title/Title";
import { IHeaderType } from "../../../../types/types";
import { EratekDigitalSolutions } from "../../../../assets/data/sme-africa/smesAfrica";
import SMEsCard from "./SMEsCard";

export default function SMEsInAfrica() {
  const { eratekHelpHighlights } = EratekDigitalSolutions();
  const { whiteColor, secondaryColor } = Colors();
  return (


    <section
      id="smes-in-africa"
      className="section smes-in-africa "
      style={{
        backgroundColor: "#201f4f",
        padding: "100px 0",
        marginBottom: "0",
      }}
    >
      <Container>
        <Row>
          <Col>
            <SMEsHeader>
              <TitleWrapper>
                <Title
                  textColor={whiteColor}
                  text={"Other Ways"}
                  style={{
                    margin: 0,
                    fontWeight: 700,
                    fontSize: "48px",
                  }}
                  type={IHeaderType.h3}
                />
                <Title
                  textColor={secondaryColor}
                  text={"Eratek"}
                  style={{
                    margin: 0,
                    fontWeight: 700,
                    fontSize: "48px",
                  }}
                  type={IHeaderType.h3}
                />
                <Title
                  textColor={whiteColor}
                  text={"Can Help You"}
                  style={{
                    margin: 0,
                    fontWeight: 700,
                    fontSize: "48px",
                  }}
                  type={IHeaderType.h3}
                />
              </TitleWrapper>

              <Text
                style={{
                  maxWidth: "630px",
                }}
              >
                Uncover solutions tailored for growth. Strategies crafted for
                impact. Services designed for transformation. Explore what we
                offer businesses like yours.
              </Text>
            </SMEsHeader>
          </Col>
        </Row>

        <Row
          style={{
            marginTop: "40px",
          }}
        >
          {eratekHelpHighlights.map((eratekHelp) => (
            <Col
              key={eratekHelp.id}
              sm={12}
              md={6}
              lg={4}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <SMEsCard {...eratekHelp} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

const SMEsHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 20px;
`;

const Text = styled.p`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  text-align: center;
  color: #ffffff;
`;

const TitleWrapper = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;
